import { Box, styled } from "@mui/material";

export const AlertContainer = styled(Box)`
  background-color: #DCEFF7;
  width: 100%;
  border-radius: 8px;
  padding: 16px 32px;
`

export const IconContainer = styled(Box)`
  background-color: #0057FF10;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #0057FF;
`